export default {
  templateTab: {
    TemplateLibrary: 'Biểu Đồ Mẫu',
    myTemplate: 'Biểu Đồ Cá Nhân',
  },
  description: 'Miêu tả',
  name: 'Tên',
  save: 'Lưu',
  cancel: 'Hủy Bỏ',
  saveChartLayout: 'Lưu Biểu Đồ',
  nameIsRequired: 'Bắt Buộc Điền Tên',
  loadTemplate: 'Tải Biểu Mẫu',
  saveTemplate: 'Lưu Biểu Mẫu',
  copyToClipboard: 'Sao Chép',
  shareChartLayout: 'Chia Sẻ Biểu Đồ',
  copy: 'Sao Chép',
  share: 'Chia Sẻ',
  deleteTemplate: 'Xóa Biểu Mẫu',
  noTemplate: 'Không Có Biểu Mẫu',
  search: 'Tìm Kiếm',

  revenue: 'Doanh Thu: %{value}',
  profit: 'Lợi NHuận: %{value}',
  periodEnding: 'Kỳ Báo Cáo: %{value}',
  dividends: 'Cổ Tức: %{value}',
  exRatio: 'Tỷ Lệ Chi Trả: %{value} %',
  exrightDate: 'Ngày GDKHQ: %{value}',
  planVolume: 'KL dự kiến: %{value}',
  issueMethod: 'Hình thức Phát Hành: %{value}',
  exIssueDate: 'Ngày Thực Hiện: %{value}',
  traderName: 'Tên: %{value}',
  buy: 'Đã mua: %{value}',
  sell: 'Đã bán: %{value}',
  volume: 'Khối Lượng: %{value}',
  confirmDelete: 'Bạn có chắc ?',

  buyRegister: 'Đăng ký mua:  %{value}',
  sellRegister: 'Đăng ký bán:  %{value}',
  buyNotHappen: 'Đăng Ký mua %{value}',
  sellNotHappen: 'Đăng Ký bán %{value}',
  buyNotHappenStatus: 'Trạng thái: Không thực hiện',
  sellNotHappenStatus: 'Trạng thái: Không thực hiện',
};
